import { Builder } from '@builder.io/react';
import dynamic from 'next/dynamic';
import { Icon, Url } from '#const';
import { getIconUrl } from '#utils';

const Listicle = dynamic(() => import('./Listicle'));

Builder.registerComponent(Listicle, {
	name: 'Listicle',
	inputs: [
		{
			name: 'displayHeading',
			friendlyName: 'Display Heading and Copy',
			type: 'boolean',
			defaultValue: true,
		},
		{
			name: 'heading',
			friendlyName: 'Heading',
			type: 'richText',
			required: false,
			defaultValue: '<h2>Time is limited - Fill out the form to see if you qualify!</h2>',
			// eslint-disable-next-line object-shorthand
			showIf: function (options) {
				return options.get('displayHeading') === true;
			},
		},
		{
			name: 'copy',
			friendlyName: 'Text',
			type: 'richText',
			defaultValue: '<p>Placeholder body text.</p>',
			// eslint-disable-next-line object-shorthand
			showIf: function (options) {
				return options.get('displayHeading') === true;
			},
		},
		{
			name: 'cardStyling',
			friendlyName: 'Card Styling',
			type: 'boolean',
			defaultValue: false,
			helperText: 'Style the columns with card outlines?',
		},
		{
			name: 'backgroundColor',
			friendlyName: 'Background Color',
			type: 'color',
			defaultValue: '#F9FAFB',
			helperText: 'Be sure to select a color light enough for the text to have contrast.',
		},
		{
			name: 'maxColumns',
			friendlyName: 'Maximum Columns',
			type: 'number',
			defaultValue: 3,
			min: 1,
			max: 6,
		},
		{
			name: 'itemHeight',
			friendlyName: 'Item Height',
			type: 'number',
			defaultValue: 400,
			helperText: 'Height of each item in pixels',
		},
		{
			name: 'useCollection',
			friendlyName: 'Use Lawsuit Collection',
			type: 'boolean',
			defaultValue: false,
			helperText: 'Pull items from a Lawsuit Collection instead of manual entry',
		},
		{
			name: 'lawsuitCollection',
			friendlyName: 'Lawsuit Collection',
			type: 'reference',
			model: 'lawsuit-collection',
			required: false,
			// eslint-disable-next-line object-shorthand
			showIf: function (options) {
				return options.get('useCollection') === true;
			},
		},
		{
			name: 'items',
			friendlyName: 'Items',
			type: 'list',
			// eslint-disable-next-line object-shorthand
			showIf: function (options) {
				return options.get('useCollection') !== true;
			},
			subFields: [
				{
					name: 'image',
					friendlyName: 'Image',
					type: 'file',
					allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
				},
				{
					name: 'heading',
					friendlyName: 'Item Heading',
					type: 'richText',
					defaultValue: '<h4>Legal Case</h4>',
				},
				{
					name: 'copy',
					friendlyName: 'Item Text',
					type: 'richText',
					defaultValue:
						'<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. \
                    Sed do eiusmod tempor incididunt ut labore</p>',
				},
				{
					name: 'button',
					friendlyName: 'Item Button',
					type: 'object',
					subFields: [
						{
							name: 'buttonText',
							friendlyName: 'Button Text',
							type: 'string',
							defaultValue: 'See if I Qualify',
						},
						{
							name: 'buttonColor',
							friendlyName: 'Button Color',
							type: 'color',
							defaultValue: '#089BAB',
						},
						{
							name: 'buttonHref',
							friendlyName: 'Button Link',
							type: 'string',
							defaultValue: '/qualify',
						},
					],
				},
				{
					name: 'horizontalRule',
					friendlyName: 'Horizontal Rule',
					type: 'boolean',
					defaultValue: false,
					helperText: 'Should there be a horizontal rule between text and heading?',
				},
				{
					name: 'hrColor',
					friendlyName: 'Horizontal Rule Color',
					type: 'color',
					defaultValue: '#FEDE49',
					// eslint-disable-next-line object-shorthand
					showIf: function (options) {
						return options.get('horizontalRule') === true;
					},
				},
			],
			// eslint-disable-next-line @typescript-eslint/no-explicit-any, object-shorthand
			onChange: function (options: any) {
				if (options.get('columns').length > 4) {
					options.set('columns', options.get('columns').slice(0, 4));
					alert('Maximum items is 4, delete item to continue.');
				}
			},
			defaultValue: [
				{
					image: Url.PLACEHOLDER,
					copy: '<p>Placeholder body text.</p>',
				},
			],
		},
		{
			name: 'usePageColors',
			friendlyName: 'Use Page Colors',
			type: 'boolean',
			defaultValue: true,
			helperText: `If true, will use colors set on page for styling;
			if false, use the controls below`,
		},
		{
			name: 'buttonBackgroundColor',
			friendlyName: 'Button Background Color',
			type: 'color',
			defaultValue: '#555555',
			helperText: 'Be sure to select a color light enough for the text to have contrast',
			// eslint-disable-next-line object-shorthand
			showIf: function (options) {
				return options.get('usePageColors') === false;
			},
		},
	],
	canHaveChildren: true,
	defaultChildren: [
		{
			'@type': '@builder.io/sdk:Element',
			component: {
				name: 'Button',
				options: {
					copy: 'See if I Qualify',
					arrow: true,
					color: '#089BAB',
				},
			},
		},
	],
	childRequirements: {
		message: 'Child must be a Button.',
		query: { 'component.name': { $eq: 'Button' } },
	},
	image: getIconUrl(Icon.COLUMNS),
});
